import { Hero } from '../../../_blocks/hero/Hero';
import { SwiperManager } from '../components/SwiperManager';
import { DomHelper } from '../modules/DomHelper';

/**
 * HomePage — トップページ固有の初期化
 * body[data-page="home"] のときのみ実行される
 *
 * Swipers:
 *   .js-brands-swiper  … ブランド（全幅1枚・フラクション "01 / 04"・カスタムナビ）
 *   .js-usecase-swiper … 導入事例（全幅・複数表示・フラクション・カスタムナビ）
 *   .js-column-swiper  … コラム（SP:1枚 / PC:3枚全表示・フラクション・カスタムナビ）
 */
export class HomePage {
  private readonly swiperManager: SwiperManager;
  private hero: Hero | null = null;

  constructor() {
    this.swiperManager = new SwiperManager();
  }

  init(): void {
    this.initHero();
    this.initBrandsSwiper();
    this.initUseCaseSwiper();
    this.initColumnSwiper();
    this.initCtaTracking();
  }

  /** ヒーロー3スライダー（メイン即時 / サブはスクロールアニメ完了後） */
  private initHero(): void {
    const el = DomHelper.qs<HTMLElement>('.p-hero');
    if (!el) return;
    this.hero = new Hero(el);
    this.hero.init();
  }

  /** ブランドスライダー（全幅1枚・フラクション "01 / 04"） */
  private initBrandsSwiper(): void {
    this.swiperManager.init('.js-brands-swiper', SwiperManager.presets.brands);
  }

  /** 導入事例スライダー（全幅・SP:1.15枚 / PC:3.2枚） */
  private initUseCaseSwiper(): void {
    this.swiperManager.init('.js-usecase-swiper', SwiperManager.presets.usecase);
  }

  /** コラムスライダー（SP:1枚 / PC:3枚全表示・loop:false） */
  private initColumnSwiper(): void {
    this.swiperManager.init('.js-column-swiper', SwiperManager.presets.column);
  }

  /** CTA クリック / 電話リンクの GTM イベント計測 */
  private initCtaTracking(): void {
    DomHelper.qsa<HTMLElement>('.js-cta-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        DomHelper.pushDataLayer({
          event: 'cta_click',
          cta_text: btn.textContent?.trim(),
          cta_location: btn.dataset.ctaLocation ?? 'unknown',
        });
      });
    });

    DomHelper.qsa<HTMLAnchorElement>('a[href^="tel:"]').forEach((link) => {
      link.addEventListener('click', () => {
        DomHelper.pushDataLayer({
          event: 'tel_click',
          tel_number: link.href.replace('tel:', ''),
        });
      });
    });
  }

  destroy(): void {
    this.hero?.destroy();
    this.swiperManager.destroyAll();
  }
}
